import React, { useEffect } from "react";
import api from "../../../common/lib/api";
import Managed, { useManaged } from "../../../common/components/Managed";
import CompaniesSelection from "./CompanySelection";

const DEFAULT_SYSTEM_STATE = {
  system: "",
  systems: [],
};

export default function SystemSelection() {
  const [state, setState, setError] = useManaged(DEFAULT_SYSTEM_STATE);

  const { data } = state;

  useEffect(() => {
    if (!data.system) {
      (async () => {
        try {
          const {
            data: { data: systems, system },
          } = await api.get("/bill-data-report/systems");

          const newSystem =
            system && systems.indexOf(system) !== -1 ? system : systems[0];

          setState({
            system: newSystem,
            systems,
          });
        } catch (e) {
          setError(e);
        }
      })();
    }
  }, [setError, setState, data.system]);

  return (
    <Managed state={state}>
      <h1>Billing Data</h1>
      <Options
        label="System"
        value={data.system}
        options={data.systems.map((system) => ({
          label: system,
          value: system,
        }))}
        onChange={(value) => {
          setState((state) => ({ ...state, system: value }));
        }}
      />
      <TimeSelection system={data.system} />
    </Managed>
  );
}

function Options({ label, value, onChange, options }) {
  return (
    <div>
      <strong>{label}: </strong>
      {options.length <= 1 && <span>{value}</span>}
      {options.length > 1 && (
        <div class="bp3-html-select">
          <select
            onChange={(e) => {
              onChange(e.target.value);
            }}
          >
            {options.map((option) => {
              return (
                <option selected={value === option.value} value={option.value}>
                  {option.label}
                </option>
              );
            })}
          </select>
        </div>
      )}
    </div>
  );
}

const DEFAULT_TIMES_STATE = {
  period: "",
  times: [],
};

function TimeSelection({ system }) {
  const [state, setState, setError] = useManaged(DEFAULT_TIMES_STATE);

  const { data } = state;

  useEffect(() => {
      (async () => {
        try {
          const {
            data: { data: times },
          } = await api.get("/bill-data-report/" + system + "/times");

          const period = data.period;

          const newPeriod = period && times.indexOf(period) !== -1 ? period : times[0];

          setState((state) => ({
            ...state,
            period: newPeriod || 'error',
            times,
          }));
        } catch (e) {
          setError(e);
        }
      })();
  }, [setError, setState, system, data.period]);

  return (
    <Managed state={state}>
      <Options
        label="Period"
        value={data.period}
        options={data.times.map((period) => ({
          label: period,
          value: period,
        }))}
        onChange={(value) => {
          setState((state) => ({ ...state, period: value }));
        }}
      />
      <CompaniesSelection system={system} period={state.data.period} />
    </Managed>
  );
}
